// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"1":"af7cbc55","375":"abd7f5da","980":"ac1292b5"}[chunkId] + ".js";
};